import React, { HTMLAttributeAnchorTarget, ReactNode } from 'react';
import { SvgChevronSmallRight } from '@getgrover/ui';

import {
  MenuIconWrapper,
  MenuItemWrapper,
  MenuItemContent,
  MenuItemText,
  MenuItemTitle,
  MenuItemDescription,
} from './MenuItem.styles';

interface MenuItemProps {
  description?: string;
  disabled?: boolean;
  href?: string;
  icon?: ReactNode;
  onClick?: () => void;
  target?: HTMLAttributeAnchorTarget;
  title: string;
}

export const MenuItem = ({
  description,
  disabled = false,
  href,
  icon = null,
  onClick = () => null,
  target,
  title,
}: MenuItemProps): JSX.Element => (
  <MenuItemWrapper
    $disabled={disabled}
    onClick={() => (!disabled ? onClick() : null)}
    {...(!disabled &&
      href && {
        as: 'a',
        href,
        target,
        ...(target === '_blank' && { rel: 'noopener noreferrer' }),
      })}
  >
    {icon ? <MenuIconWrapper>{icon}</MenuIconWrapper> : null}
    <MenuItemContent>
      <MenuItemText>
        <MenuItemTitle>{title}</MenuItemTitle>
        {!!description && <MenuItemDescription>{description}</MenuItemDescription>}
      </MenuItemText>
      <SvgChevronSmallRight />
    </MenuItemContent>
  </MenuItemWrapper>
);
